// extracted by mini-css-extract-plugin
export var logoIcon = "logo-icon_Wj7UV9xYC5nqJhZowU0u";
export var main = "main_dnU5r21WIwl_gSsP52Jq";
export var mainHeader = "main-header_ohg_8fE7Af7rZCw7zt8j";
export var mainStickyContainer = "main-sticky-container_fxMebnJPGdq7rP9_gAYu";